// Reviews.io Rating Widget Clickability
document.addEventListener('DOMContentLoaded', () => {
    const reviewsTab = document.querySelector('#tab-5');

    if (reviewsTab) {
        // Function to make Reviews.io rating clickable
        function makeReviewsioClickable() {
            const reviewsioRating = document.querySelector('.ruk_rating_snippet');
            const reviewsioWidget = document.querySelector('reviewsio-product-ratings');

            if (reviewsioRating) {
                reviewsioRating.style.cursor = 'pointer';
                reviewsioRating.addEventListener('click', (e) => {
                    e.preventDefault();
                    reviewsTab.click();
                    reviewsTab.scrollIntoView({ behavior: 'smooth', block: 'start' });
                });
            }

            if (reviewsioWidget) {
                reviewsioWidget.style.cursor = 'pointer';
                reviewsioWidget.addEventListener('click', (e) => {
                    e.preventDefault();
                    reviewsTab.click();
                    reviewsTab.scrollIntoView({ behavior: 'smooth', block: 'start' });
                });
            }
        }

        // Try immediately
        makeReviewsioClickable();

        // Also try after delays in case the widget loads later
        setTimeout(makeReviewsioClickable, 1000);
        setTimeout(makeReviewsioClickable, 2000);
        setTimeout(makeReviewsioClickable, 3000);
    }
});
